module.exports = __webpack_public_path__ + "img/twitter_logo.d7b4abcb.svg";